import Head from "next/head";

type Props = {
  title?: string;
  content?: string;
  pageSlug?: string;
  pageType?: string;
  ogImage?: string;
};

export default function CustomHead({ title, content, pageSlug, pageType = "website" }: Props) {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={content} />
      <meta property="og:type" content={pageType} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={content} />
    </Head>
  );
}
